import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AbstractMediator from "../../../../../../../shared/src/ranj/app/ui/AbstractMediator";
import CollaborationDialogPlayer from "../CollaborationDialogPlayer";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";

export class AbstractDialogPlayerOptionsMediator extends AbstractMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);

        this._dialogPlayer;

        this._onDialogOptionsChangedBound = this._onDialogOptionsChanged.bind(this);
        this._onDialogOptionChosenBound = this._onDialogOptionChosen.bind(this);
        this._onDialogEndBound = this._onDialogEnd.bind(this);
    }

    destroy() {
        this._removeDialogPlayerListeners();
    }

    // ------------------------------------------
    //  Abstract functions (to override)
    // ------------------------------------------
    _handleDialogOptionsChanged() { }

    // ------------------------------------------
    //  Dialog listeners
    // ------------------------------------------
    _addDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    _removeDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;

        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    // ------------------------------------------
    //  Dialog handlers
    // ------------------------------------------
    _onDialogOptionsChanged(event) {
        this._handleDialogOptionsChanged();
    }

    _onDialogOptionChosen({ params }) {
        this._handleDialogOptionChosen(params.data.option);
    }

    _onDialogEnd(event) {
        this.setDialogPlayer(null);
    }

    _handleDialogOptionChosen(option){
    }

    // ------------------------------------------
    // Content delegates
    // ------------------------------------------

    /**
     * 
     * @returns {CollaborationDialogPlayer}
     */
    getDialogPlayer() {
        return this._dialogPlayer;
    }

    /**
     * 
     * @param {CollaborationDialogPlayer} value 
     */
    setDialogPlayer(value) {
        if (!isNull(this._dialogPlayer)) {
            this._removeDialogPlayerListeners();
        }

        this._dialogPlayer = value;

        if (this._dialogPlayer !== null) {
            this._addDialogPlayerListeners();
        }
    }

    show() {
        this._target.visible = true;
    }

    hide() {
        this._target.visible = false;
    }
}




